import {Module} from '@fantasmagames/slot/src/common/Module';
import {Views} from '@fantasmagames/slot/src/common/view/Views';
import {AutoplayHandlerEvents} from '@fantasmagames/slot/src/modules/autoplay/AutoplayHandlerEvents';
import {FlowModuleEvents} from '@fantasmagames/slot/src/modules/flow/FlowModuleEvents';
import {MenuButtonEvents} from '@fantasmagames/slot/src/modules/keypad/menuButton/MenuButtonEvents';
import {MenuButtonView} from '@fantasmagames/slot/src/modules/keypad/menuButton/MenuButtonView';
import {MenuButtonViewEvents} from '@fantasmagames/slot/src/modules/keypad/menuButton/MenuButtonViewEvents';
import {MenuButtonBasicState} from '@fantasmagames/slot/src/modules/keypad/menuButton/states/MenuButtonBasicState';
import {StopAutoplayButtonEvents} from '@fantasmagames/slot/src/modules/keypad/stopautoplaybutton/StopAutoplayButtonEvents';
import {InfoPopupEvents} from '@fantasmagames/slot/src/modules/popupmenus/info/InfoPopupEvents';
import {InfoPopupTypes} from '@fantasmagames/slot/src/modules/popupmenus/info/InfoPopupTypes';
import {ReelsEvents} from '@fantasmagames/slot/src/modules/reels/spin/ReelsEvents';
import {StartScreenEvents} from '@fantasmagames/slot/src/modules/startscreen/StartScreenEvents';
import {FreeSpinsEvents} from '@fantasmagames/slot/src/modules/freespins/intro/FreeSpinsEvents';

export class MenuButtonModule extends Module<MenuButtonView> {
	public static readonly BASIC_STATE: string = 'basic';
	public static readonly MENUBUTTON_CLICKED_STATE: string = 'menuButtonClicked';

	protected _autoPlayActive: boolean = false;
	protected _startscreenExitFinished: boolean = false;

	public afterInit(): void {
		super.afterInit();

		this.hideMenuButton();
	}

	public restore(): void {
		super.restore();

		this.view.showMenuButton();
	}

	protected setupViews(): void {
		if (this.system.shouldUseMultipleViews()) {
			this.setView(Views.MENUBUTTON_VIEW_MOBILE);
		} else {
			this.setView(Views.MENUBUTTON_VIEW);
		}
	}

	protected setupEvents(): void {
		super.setupEvents();

		this.onCurrentStateHandle(ReelsEvents.SPIN_ENDED);
		this.onCurrentStateHandle(ReelsEvents.REELS_RESPIN_STARTED);

		this.on(FlowModuleEvents.CAN_SPIN, this.onCanSpin);
		this.onView(MenuButtonViewEvents.MENU_BUTTON_CLICKED, this.onMenuButtonClicked);
		this.on(StartScreenEvents.EXIT_FINISHED, this.onStartScreenExitFinished);
	}

	protected enterFirstState(): void {
		this.changeStateTo(MenuButtonModule.BASIC_STATE);
	}

	protected setupStates(): void {
		this.addState(new MenuButtonBasicState(this, MenuButtonModule.BASIC_STATE));
	}

	protected onStartScreenExitFinished(): void {
		this._startscreenExitFinished = true;
		this.showMenuButton();
	}

	protected onCanSpin(): void {
		if (this._startscreenExitFinished) {
			this.showView();
			this.showMenuButton();
		}

		this.enableMenuButton();
	}

	protected showView(): void {
		this.view.show();
	}

	protected hideView(): void {
		this.view.hide();
	}

	protected enableMenuButton(): void {
		this.view.enableMenuButton();
	}

	protected disableMenuButton(): void {
		this.view.disableMenuButton();
	}

	protected showMenuButton(): void {
		this.view.showMenuButton();
	}

	protected hideMenuButton(): void {
		this.view.hideMenuButton();
	}

	protected onMenuButtonClicked(): void {
		this.eventManager.emit(MenuButtonEvents.MENU_BUTTON_CLICKED);
	}

}



// WEBPACK FOOTER //
// ./@fantasmagames/slot/src/modules/keypad/menuButton/MenuButtonModule.ts